var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8005 19.893V27.7683H24.0545V20.8414C24.0545 19.9786 24.0534 18.8651 23.7001 17.9694C23.5177 17.5071 23.2329 17.0771 22.7879 16.7662C22.3417 16.4545 21.7774 16.2924 21.0887 16.2924C20.4061 16.2924 19.8318 16.426 19.3593 16.6878C18.884 16.9511 18.5418 17.3278 18.3008 17.7652C17.8319 18.6165 17.7415 19.7097 17.7415 20.7152V27.7683H14.0009V13.4968H17.5504V15.0848V15.5848H18.0504H18.1162H18.4178L18.5585 15.318C19.1088 14.2737 20.4914 13.1181 22.6061 13.1181C24.8861 13.1181 26.1247 13.8573 26.8327 14.9799C27.5741 16.1553 27.8005 17.8475 27.8005 19.893ZM8.14967 10.4105C6.90164 10.4105 5.89582 9.40175 5.89582 8.15753C5.89582 6.91431 6.90154 5.90546 8.14967 5.90546C9.39148 5.90546 10.4 6.91421 10.4 8.15753C10.4 9.40185 9.39137 10.4105 8.14967 10.4105ZM10.024 13.4968V27.7683H6.27272V13.4968H10.024ZM30.6641 0.5H3.39132C1.82376 0.5 0.53125 1.74605 0.53125 3.30762V30.6915C0.53125 32.2526 1.82326 33.5009 3.39132 33.5009H30.6641C32.2332 33.5009 33.5312 32.2541 33.5312 30.6915V3.30762C33.5312 1.74448 32.2327 0.5 30.6641 0.5Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.985d88a7740c22015dd467cefec1ad26.svg";
export { ForwardRef as ReactComponent };